import {takeLatestF} from '@fl/cmsch-fe-library';
import {SagaIterator} from 'redux-saga';
import {put} from 'typed-redux-saga';

import {Api} from 'api/gen/Api';
import {tablesAction} from 'utils/tables';

import {userAction, GetUserOrganizationsAction} from '../action';

const tableId = 'organizationsProfile';

function* execute({payload: {tableDataRequest}}: GetUserOrganizationsAction): SagaIterator {
    yield* put(tablesAction.getTableData({
        tableDataRequest,
        apiRequest: Api.findLoggedInUserOrganizationRoles,
        successAction: userAction.getUserOrganizationsSuccess,
        tableId,
    }));
}
export function* getUserOrganizationsSaga(): SagaIterator {
    yield takeLatestF('user/GET_USER_ORGANIZATIONS', execute);
}
